import React, { useEffect, useRef } from 'react';
import { theme } from 'styles/theme';
import { useThemeContext } from 'context/ThemeContext/ThemeContext';
import { ReactComponent as LoadingAnimation } from 'assets/icons/svg/loading.svg';

type LoadingIndicatorProps = {
  color?: string;
  size?: string;
  styles?: string;
  speed?: number;
};

const LoadingIndicator: React.FC<LoadingIndicatorProps> = ({
  color,
  styles = '',
  size = '60px',
  speed = 1,
}) => {
  const { brandTheme } = useThemeContext();
  const svgRef = useRef<SVGSVGElement>(null);

  useEffect(() => {
    if (svgRef.current) {
      const animateTransform = svgRef.current.querySelector('animateTransform');
      if (animateTransform) animateTransform.setAttribute('dur', `${speed}s`);
    }
  }, [speed]);

  useEffect(() => {
    if (!document.getElementById('loading-indicator-keyframes')) {
      const style = document.createElement('style');
      style.id = 'loading-indicator-keyframes';
      style.textContent = `
        @keyframes loading-spin {
          from {
            transform: rotate(0deg);
          }
          to {
            transform: rotate(360deg);
          }
        }
      `;
      document.head.appendChild(style);
    }
  }, []);

  return (
    <LoadingAnimation
      ref={svgRef}
      className={styles}
      stroke={color || brandTheme || theme.primary}
      height={size}
      width='100%'
      aria-hidden
    />
  );
};

export default LoadingIndicator;
